import { render, staticRenderFns } from "./BatchUploaderWrapper.vue?vue&type=template&id=123bd983&lang=pug&"
import script from "./BatchUploaderWrapper.vue?vue&type=script&lang=js&"
export * from "./BatchUploaderWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports